import React from 'react'
import portfolio1 from '../images/bg-2.png'

const Header = () => {
    return (
        <div className="header">
            <div className="container">
            <div className="row">
                <div className="col-lg-6 col-md-6 col-10 mx-sm-auto">
                    <div className="header__1">
                    <h4>looking for designer</h4>
                    <h1>i'm <span>Huzaifa</span> Ansari </h1>
                        <p>Obviously i'm a web developer & designer with over 3 years of experience.experienced with all stages of developement cycle
                            for dynamic web projects</p>
                            <div className="row mt-3 header__2 ">
                                <div className="col-md-3 col-5">
                                    <button href="#" className="btn btn-default" id="btn__1"> Hire Me</button>
                                </div>
                                <div className="col-md-3 col-5 mx-md-5 mx-lg-0 mx-sm-0">
                                    <button href="#" className="btn btn-default" id="btn__2"> Download CV</button>
                                </div>
                            </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-10">
                    <img src={portfolio1} alt="portfolio-img" id="img__1" className="img-fluid mt-3" />
                </div>
            </div> 
        </div>
        </div>
    )
}

export default Header
